import useQuery from '../../../util/useQuery';
import Content from './Cookie/Content';
import Style from './Cookie/Style';
import SettingStyle from './Setting/Style';

const Customize = ({ form ,setLogoId}) => {
    const params = useQuery();
    const tab = params.get('tab') || '1';
    return (
        <div className="col-span-1 bg-white p-4 mt-4 rounded-md space-y-4 h-max">
            {tab === '1' ? (
                <>
                    <Content form={form} />
                    <Style form={form} setLogoId={setLogoId} />
                </>
            ) : (
                <SettingStyle form={form} />
            )}
        </div>
    );
};

export default Customize;
